/**
 * BeyBling storefront analytics — dataLayer events for GTM / GA4.
 * Safe no-op when dataLayer is absent until GTM is installed.
 */

/**
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackBeyblingEvent(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
}

document.addEventListener(
  'cart:update',
  (event) => {
    if (!(event instanceof CustomEvent)) return;
    if (event.detail?.data?.didError) return;

    const source = event.detail?.data?.source;
    if (typeof source !== 'string' || !source.includes('quick-add')) return;

    trackBeyblingEvent('beybling_quick_add', {
      product_id: event.detail?.data?.productId,
      variant_id: event.detail?.data?.variantId,
      item_count: event.detail?.data?.itemCount,
    });
  },
  { passive: true }
);

document.addEventListener(
  'beybling:free-shipping-unlocked',
  () => {
    trackBeyblingEvent('beybling_free_shipping_unlocked');
  },
  { passive: true }
);

document.addEventListener(
  'click',
  (event) => {
    const target =
      event.target instanceof Element ? event.target.closest('[data-beybling-analytics]') : null;
    if (!(target instanceof HTMLElement)) return;

    trackBeyblingEvent('beybling_click', {
      action: target.dataset.beyblingAnalytics,
      href: target instanceof HTMLAnchorElement ? target.href : undefined,
    });
  },
  { passive: true }
);
